import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
import bankList from '@/const/bank';
import bondAgree from '../bondAgree/index.page.vue';
var formData = {
  payerAccountName: '',
  payerAccount: '',
  payerBankName: '',
  depositAmount: undefined,
  depositImage: ''
};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  meta: {
    title: '保证金补足缴纳',
    auth: true,
    authorityValue: "store-store-bond-info"
  },
  name: 'bondMake',
  components: {
    bondAgree: bondAgree
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      options: bankList,
      checked: false,
      formData: formData,
      rules: utilRules(rulelist),
      record: {},
      payData: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getQiNiu();

              _this.depositInfo();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    depositInfo: function depositInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.depositInfo();

              case 2:
                _this2.record = _context2.sent;
                _context2.next = 5;
                return _this2.$api.depositList();

              case 5:
                _this2.payData = _context2.sent;
                console.log('record', _this2.record);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['loginForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    submit: function submit() {
      var _this3 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  if (_this3.checked) {
                    _context3.next = 4;
                    break;
                  }

                  return _context3.abrupt("return", YL.message('请先阅读并同意《要炼诚信保证金》协议', 'error'));

                case 4:
                  _context3.next = 6;
                  return _this3.$api.deposit(_this3.formData);

                case 6:
                  _this3.goBack();

                  _this3.$router.replace('/bondWait');

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};